import { authApi } from "./index";

// --- GROUP 1: BROWSE ---

export const getAllCertifications = async () => {
  try {
    const response = await authApi.get("/UserCertification/getallactivecertificate");
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getAllCertificationsAuth = async () => {
  try {
    const response = await authApi.get("/UserCertification/getallactiveusercertificate");
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getCertificationDetail = async (certificationId) => {
  try {
    const response = await authApi.get(`/UserCertification/${certificationId}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getCertificationModules = async (certificationId) => {
  try {
    const response = await authApi.get(
      `/UserCertification/${certificationId}/modules`
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getCertificationQuestions = async (certificationId) => {
  try {
    const response = await authApi.get(
      `/UserCertification/${certificationId}/questions`
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

// --- GROUP 2: ENROLLMENT & EXAM ---

export const enrollCertification = async (certificationId) => {
  try {
    const response = await authApi.post("/CertificationApplication", {
      certificationId,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getMyApplications = async (status) => {
  try {
    const params = status ? { status } : {};
    const response = await authApi.get("/CertificationApplication", { params });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getApplicationById = async (applicationId) => {
  try {
    const response = await authApi.get(
      `/CertificationApplication/${applicationId}`
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const startApplication = async (applicationId) => {
  try {
    const response = await authApi.patch(
      `/CertificationApplication/${applicationId}/start`
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const cancelApplication = async (applicationId) => {
  try {
    const response = await authApi.delete(
      `/CertificationApplication/${applicationId}`
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const submitExam = async (applicationId, answers) => {
  try {
    const response = await authApi.post(
      `/CertificationApplication/${applicationId}/submit-exam`,
      { answers }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getExamResult = async (applicationId) => {
  try {
    const response = await authApi.get(
      `/CertificationApplication/${applicationId}/result`
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

// --- GROUP 3: EARNED CERTIFICATES ---

export const getMyCertificates = async () => {
  try {
    const response = await authApi.get("/UserCertificate");
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getCertificateDetail = async (userCertificateId) => {
  try {
    const response = await authApi.get(
      `/UserCertificate/${userCertificateId}`
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

// PDF download — returns a Blob; error body is parsed from blob if request fails
export const downloadCertificatePdf = async (userCertificateId) => {
  try {
    const response = await authApi.get(
      `/UserCertificate/${userCertificateId}/download`,
      { responseType: "blob" }
    );
    return response.data; // Blob
  } catch (error) {
    // If the server returned an error body as a blob, parse it as JSON
    if (error.response?.data instanceof Blob) {
      try {
        const text = await error.response.data.text();
        const json = JSON.parse(text);
        throw new Error(json.message || "Download failed");
      } catch {
        // ignore parse failure, re-throw original
      }
    }
    throw error;
  }
};

export const createCertificationCheckoutSession = async (applicationId, successUrl, cancelUrl) => {
  try {
    const response = await authApi.post(
      "/Payments/certification-checkout-session",
      { applicationId, successUrl, cancelUrl }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
